// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js';
import systemConfig from '../static/config/systemConfig'
import {cHttp} from 'common/js/httpRequest'
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
import {Checklist,Picker,Popup,Button,Cell,Toast,MessageBox,Actionsheet,Indicator,InfiniteScroll,Lazyload,Field} from 'mint-ui'
import 'common/css/cssreset.css'
import 'common/css/paramcss.scss'
// Vue.use(MintUI)
Vue.component(Checklist.name,Checklist)
Vue.component(Picker.name,Picker)
Vue.component(Popup.name,Popup)
Vue.component(Toast.name,Toast)
Vue.component(Button.name,Button)
Vue.component(Field.name,Field)
Vue.component(Actionsheet.name,Actionsheet)
Vue.use(InfiniteScroll);
Vue.use(Lazyload);
Vue.use(Actionsheet);
Vue.$messagebox = Vue.prototype.$messagebox = MessageBox;
Vue.$toast = Vue.prototype.$toast = Toast;
Vue.$indicator = Vue.prototype.$indicator = Indicator;
Vue.$indicator = Vue.prototype.$Actionsheet = Actionsheet;

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.prototype.$systemConfig=systemConfig
Vue.prototype.$cHttp=cHttp

router.beforeEach((to, from, next) => {
  //如果不是微信浏览器则跳转至手机页面
  let ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    window.location.href = 'http://m.rhawn.cn';
  }
  next();
});

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})
document.body.addEventListener('touchstart', function () {});



// WEBPACK FOOTER //
// ./src/main.js